import ActiveSessionsIcon from './images/profile/activeSessionsIcon.svg';
import AddressIcon from './images/profile/addressIcon.svg';
import ArrowSelectIcon from './images/profile/arrowSelectIcon.svg';
import ChangePasswordIcon from './images/profile/changePasswordIcon.svg';
import CoolingOffIcon from './images/profile/coolingOffIcon.svg';
import CrossIcon from './images/profile/crossIcon.svg';
import DepositHistoryRowIcon from './images/profile/depositHistoryRowIcon.svg';
import DepositLimitsIcon from './images/profile/depositLimitsIcon.svg';
import FaileFileUploadIcon from './images/profile/faileFileUploadIcon.svg';
import FileUploadIcon from './images/profile/fileUploadIcon.svg';
import IdentityIcon from './images/profile/identityIcon.svg';
import ImageIcon from './images/profile/imageIcon.svg';
import LinkBoldIcon from './images/profile/linkBoldIcon.svg';
import LossLimitsIcon from './images/profile/lossLimitsIcon.svg';
import PaymentIcon from './images/profile/paymentIcon.svg';
import PdfIcon from './images/profile/pdfIcon.svg';
import SelfExclusionIcon from './images/profile/selfExclusionIcon.svg';
import TooltipIcon from './images/profile/tooltipIcon.svg';
import TrashIcon from './images/profile/trashIcon.svg';
import TwoFactorIcon from './images/profile/twoFactorIcon.svg';
import VerifyEmailIcon from './images/profile/verifyEmailIcon.svg';
import VerifyNotificationIcon from './images/profile/verifyNotificationIcon.svg';
import WagerLimitsIcon from './images/profile/wagerLimitsIcon.svg';
import WithdrawalHistoryRowIcon from './images/profile/withdrawalHistoryRowIcon.svg';
import { getStrImagesMap, importImages } from './utils';

const images = importImages(
  (require as any).context('./images', false, /\.(png|jpe?g|svg)$/),
  (require as any).context('!@svgr/webpack!./images', true, /\.svg$/)
);

const testImages = getStrImagesMap(
  (require as any).context('./images', false, /\.(png|jpe?g|svg)$/)
);
const providers = getStrImagesMap(
  (require as any).context('./images/providers', false, /\.(png|jpe?g|svg)$/)
);

const tabBarMenu = importImages(
  (require as any).context('./images/tabBarMenu', false, /\.(png|jpe?g|svg)$/),
  (require as any).context('!@svgr/webpack!./images/tabBarMenu', true, /\.svg$/)
);

const bonusTerms = importImages(
  (require as any).context('./images/bonusTerms', false, /\.(png|jpe?g|svg)$/),
  (require as any).context('!@svgr/webpack!./images/bonusTerms', true, /\.svg$/)
);

const PROFILE_ICONS = {
  verifyNotificationIcon: VerifyNotificationIcon,
  identityIcon: IdentityIcon,
  addressIcon: AddressIcon,
  paymentIcon: PaymentIcon,
  fileUploadIcon: FileUploadIcon,
  failedFileUploadIcon: FaileFileUploadIcon,
  crossIcon: CrossIcon,
  verifyEmailIcon: VerifyEmailIcon,
  depositHistoryRowIcon: DepositHistoryRowIcon,
  withdrawalHistoryRowIcon: WithdrawalHistoryRowIcon,
  changePasswordIcon: ChangePasswordIcon,
  twoFactorIcon: TwoFactorIcon,
  activeSessionsIcon: ActiveSessionsIcon,
  depositLimitsIcon: DepositLimitsIcon,
  lossLimitsIcon: LossLimitsIcon,
  wagerLimitsIcon: WagerLimitsIcon,
  coolingOffIcon: CoolingOffIcon,
  selfExclusionIcon: SelfExclusionIcon,
  tooltipIcon: TooltipIcon,
  trashIcon: TrashIcon,
  pdfIcon: PdfIcon,
  imageIcon: ImageIcon,
  arrowSelectIcon: ArrowSelectIcon,
  linkBoldIcon: LinkBoldIcon,
};

export const PROFILE_THEME = {
  ...PROFILE_ICONS,
  white: '#FFFFFF',
  success: '#00B83E',
  successBg: '#00B83E33',
  error: '#DE2E07',
  errorBg: '#DE2E0733',
  pending: '#F0C018',
  pendingBg: '#F0C01833',
  color1: '#1C1C1E',
  color2: '#8E8E93',
  color3: '#000000',
  color4: '#FFFFFF',
  color5: '#FFFFFF',
  color7: '#FFFFFF',
  color9: '#9A9CAC',
  color10: '#42C7F3',
  color11: '#25AAD6',
  color12: '#000000',
  color20: '#636366',
  color22: '#FFFFFF',
  color23: '#FFFFFF',
  color24: '#1AB232',
  color25: '#EA5B0C',
  color27: '#FF7226',
  color32: '#25AAD6',
  color33: '#FFFFFF',
  color38: '#636366',
  color41: '#000000',
  color43: '#FFFFFF33',
  borderRadius1: '360px',
  borderRadius2: '24px',
};

const theme = {
  ...PROFILE_THEME,
  mainColor: '#EA5B0C',
  mainColorHover: '#FF7226',
  mainColorActive: '#E35202',
  secondaryColor: '#25AAD6',
  secondaryColorHover: '#42C7F3',
  secondaryColorActive: '#028EBC',
  whiteColor: '#FFFFFF',
  blackColor: '#000000',
  blackLightColor: '#8E8E93',
  solarYellow: '#ffe242',
  flameOrange: '#ea5b0c',
  grayColor: '#636366',
  grayDarkColor: '#1c1c1e',
  grayLightColor: '#1c1c1e',
  grayMegaLightColor: '#D3D3D9',
  gray1Color: '#F2F2F4',
  redColor: '#DE2E07',
  greenLightColor: '#00aa09',
  orangeColor: '#ff412b',
  greenColor: '#1AB232',
  violetColor: '#4F219A',
  goldColor: '#B16800',
  yellowColor: '#F0C018',
  yellow1Color: '#FFD500',
  yellow2Color: '#ffe225',
  yellow3Color: '#ffeb7d',
  lightBlue: '#4F79AB',
  cedarWoodColor: '#821F00',
  picassoColor: '#FFEC93',
  yellowSeaColor: '#FFAD01',
  lightVioletColor: '#854DEB',
  manateeColor: '#8E8E93',
  skeletonDarkBackgroundColor: '#1C1C1E',
  skeletonDarkForegroundColor: '#131314',
  skeletonLightBackgroundColor: '#D3D3D9',
  skeletonLightForegroundColor: '#F2F2F4',

  greenSuccessColor: '#1AB232',
  vipSuper1: '#00C4FF',
  vipSuper2: '#6416E7',
  vipSuper3: '#F13494',

  // gradient
  goldGradient: 'linear-gradient(90deg, #BD5D0D 0%, #FFEC93 50%, #BD5D0D 100%)',
  goldLightGradient: 'linear-gradient(0deg, #FFAD01 0%, #FFD500 100%)',
  freshLimeGradint: 'linear-gradient(90deg, #1AB232 19.02%, #93DB37 81.48%)',
  solarFlareGradient: 'linear-gradient(90deg, #FFAD01 19.02%, #FFD500 81.48%)',
  goldDarkGradient: 'linear-gradient(180deg, #FFEA7D 0%, #FFD500 100%)',
  blackGradient:
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 40%, #000 100%)',
  greenLightGradient:
    'linear-gradient(180deg, #CFFC94 0%, #58CE35 50%, #088717 100%)',
  greenDarkGradient:
    'linear-gradient(180deg, #D0FD95 0%, #58CE35 50%, #58CE35 100%)',

  images,
  testImages,
  providers,
  tabBarMenu,
  bonusTerms,

  jackpotIcon: images.jackpotIcon.component,
  homeIcon: images.homeIcon.component,
  homeStrokeIcon: images.homeStrokeIcon.component,
  casinoIcon: images.casinoIcon.component,
  sportsIcon: images.sportsIcon.component,
  closeIcon: images.closeIcon.component,
  notificationWithBadgeIcon: images.notificationWithBadgeIcon.component,
  lockIcon: images.lockIcon.component,
  playIcon: images.playIcon.path,
  logoMin: images.logoMin.path,
  logo: images.logo.path,
  eyeClosedIcon: images.eyeClosedIcon.path,
  eyeOpenIcon: images.eyeOpenIcon.path,

  heartIcon: images.heartIcon.component,
  heartFullIcon: images.heartFullIcon.component,
  heartIconDouble: images.heartIconDouble.component,

  whiteArrowRight: images.whiteArrowRight.component,
  arrowRightWhiteIcon: images.arrowRightWhiteIcon.component,
  checkIcon: images.checkIcon.component,
  supportIcon: images.supportIcon.component,
  profileIcon: images.profileIcon.component,
  magnifierLargeIcon: images.magnifierLargeIcon.component,
  presentIcon: images.presentIcon.component,
  notificationIcon: images.notificationIcon.component,
  newNotificationIcon: images.newNotificationIcon.component,
  menuIcon: images.menuIcon.component,
  burgerIcon: images.burgerIcon.component,
  crossIcon: images.crossWhiteIcon.component,
  crossInCircleIcon: images.crossInCircleIcon.component,
  basketIcon: images.basketIcon.component,
  envelopeIcon: images.envelopeIcon.component,
  errorIcon: images.errorIcon.component,
  successIcon: images.successIcon.component,
  warningIcon: images.warningIcon.component,
  infoIcon: images.infoIconTooltip.component,
  plusIconBoldWhite: images.plusIconBoldWhite.component,
  whiteInfoIcon: images.whiteInfoIcon.component,
  wagerIcon: images.wagerIcon.component,
  tickIcon: images.tickIcon.component,
  successCircleIcon: images.successCircleIcon.component,
};

export default theme;
